import Head from 'next/head';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import Items from '@cont/Saved/Items';
import { fetchTopologyInfo } from '@actions/topologies';
import { fetchSavedEntities } from '@actions/saved';
import { useSetSelectedNav } from '@stores/sidenav';
import { savedObjectTypes } from '@constants/index';
import { getGoalInfoByUID } from '@selectors/topologies';
import { useSelector } from 'react-redux';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import escape from '@utils/escapeHTML';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Notes = ({ goalUID }) => {
  const goalInfo = useSelector((state) => getGoalInfoByUID(state, goalUID));
  const { goalSlug, title, uid } = goalInfo;
  const goalTitle = 'My Saved Notes';
  const goalDescription = `Prepare live from Top Educators with comprehensive, structured, and crash courses along with practice section for ${title} on Unacademy Plus.`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${uid}/notes`;
  const imageURL =
    'https://static.uacdn.net/static/dist/c76c2e18c7980818a913f9467c74c567.png';

  useSetSelectedNav('saved');

  return (
    <>
      <NextSeo
        title={goalTitle}
        description={goalDescription}
        openGraph={{
          title: goalTitle,
          description: goalDescription,
          images: [
            {
              url: imageURL
            }
          ],
          url: canonicalURL
        }}
      />
      <Head>
        <title>{goalTitle}</title>
      </Head>
      <Items title="My Notes" entityType={savedObjectTypes.NOTES} />
    </>
  );
};

Notes.pageInfo = {
  isMWebSupported: true,
  name: 'Saved Notes List',
  layoutOptions: {
    showPlusNav: true
  }
};

export default Notes;

Notes.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID } = query;
    const promises = [];

    const hasGoalInfo = getGoalInfoByUID(store.getState(), goalUID);
    if (!hasGoalInfo) promises.push(store.dispatch(fetchTopologyInfo(goalUID)));

    const dataKey = `${goalUID}-notes`;

    promises.push(
      store.dispatch(
        fetchSavedEntities({
          goalUid: goalUID,
          entityType: savedObjectTypes.NOTES,
          key: dataKey,
          forceReset: true,
          resetWithoutEmpty: true
        })
      )
    );
    if (promises.length) await Promise.all(promises);
    return {
      isServer,
      goalUID: escape(goalUID)
    };
  },
  Notes.pageInfo
);

Notes.propTypes = {
  goalUID: PropTypes.string.isRequired
};
Notes.Layout = Layout;
Notes.Wrapper = PageReduxProvider;
